import styled from 'styled-components';
import Loginbg from './../../../assets/images/CustomerLogin_bg.jpg';

export const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f8f8f8;

  @media (max-width: 768px),
    (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
    (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
    (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
    flex-direction: column;
  }
`;

export const LeftSection = styled.div`
  flex: 1;
  background: url(${Loginbg}) no-repeat center center;
  background-size: cover;
  clip-path: polygon(0 0, 85% 0, 65% 100%, 0% 100%);
  position: relative;
  height: 100vh;
  z-index: 2;

  @media (max-width: 768px),
    (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
    (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
    (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
    clip-path: none;
    height: 20vh;
    flex: none;
  }
`;

export const RightSection = styled.div`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  margin-left: -25%;
  width: calc(100% + 15%);
  position: relative;
  z-index: 1;

  @media (max-width: 768px),
    (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
    (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
    (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
    margin-left: 0;
    width: 100%;
    padding: 1rem;
  }
`;

export const TopLogo = styled.div`
  position: absolute;
  top: 1rem;
  left: 60%;
  transform: translateX(-50%);
  text-align: center;

  img {
    max-width: 550px;
    height: auto;

    @media (max-width: 768px),
      (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
      (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
      (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
      max-width: 320px;
      margin-left: -10%;
    }
  }
`;

export const ContentWrapper = styled.div<{ isRegister: boolean }>`
  margin-top: ${({ isRegister }) => (isRegister ? '-5%' : '')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-left: 12rem;
  padding-top: 8rem;

  @media (max-width: 768px),
    (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
    (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
    (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
    margin-left: 0rem;
  }
`;

export const MainLogo = styled.div`
  margin-bottom: 3.5rem;

  img {
    max-width: 250px;
    height: auto;

    @media (max-width: 768px),
      (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
      (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
      (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
      margin-top: -2rem;
      max-width: 200px;
    }
  }
`;

export const FormWrapper = styled.div<{ isRegister?: boolean }>`
  max-width: ${({ isRegister }) => (isRegister ? '600px' : '400px')};
  margin-top: ${({ isRegister }) => (isRegister ? '-3%' : '')};
  width: 100%;
  text-align: center;
  transition: max-width 0.3s ease-in-out;

  h1 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;

    @media (max-width: 768px),
      (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
      (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
      (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
      font-size: 1.5rem;
    }
  }

  .ant-form-item {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 768px),
    (min-width: 768px) and (max-width: 1024px) and (orientation: portrait),
    (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait),
    (min-width: 800px) and (max-width: 1280px) and (orientation: landscape) and (max-height: 800px) {
    margin-top: -5%;
  }
`;

export const ScrollableForm = styled.div`
  max-height: 520px;
  overflow-y: auto;
  padding: 0 1rem;
  margin-bottom: 1rem;
  -webkit-overflow-scrolling: touch;
`;

export const ButtonWrapper = styled.div`
  margin-top: 1rem;

  button {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

export const RegisterLink = styled.div`
  margin-top: -2rem;
  margin: 1rem 0;
  a {
    color: #006ccf;
    text-decoration: underline;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;

  button {
    flex: 1;
    background-color: #8c1c03;
    color: white;
  }
`;
